export default __webpack_public_path__ + "static/media/telegram.786e9896.svg";